import { artBoardActions } from '@store/reducers/artboard'
import { put } from 'redux-saga/effects'

export function* enableMode() {
  yield put(artBoardActions.changeMode('seo_mode'))
}
